export class CreateInvoiceRequestModel {
    orderIds: string[];
    filterFromDateTime: Date;
    filterToDateTime: Date;
}